
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `ResellersOptions` type.
 */

type ResellersOptions = {
  locale: string,
  params?: {
    filter?: {
      [key: string]: any
    }
  }
};

/**
 * Export `fetchResellers`.
 */

export async function fetchResellers({ locale, params }: ResellersOptions) {
  const endpoint = getApiEndpoint('getResellers');

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale),
      params
    });

    return data?.data;
  } catch (error) {
    handleRequestError(error);
  }
}
